export default "__VITE_ASSET__CnwNdd00__"